/**
 * Waseem Collection - Luxury Unstitched Fashion Custom JavaScript
 * Behavior: WhatsApp dynamic message builder, Free shipping math, Dispatch timer, Notify-me
 * Author: AI Build Orchestration - Waseem Collection Plan
 */

(function () {
  'use strict';

  // 1. Same-Day Dispatch Countdown Timer (Cutoff: 6:00 PM Pakistan Standard Time)
  function initDispatchCountdown() {
    const timerEls = document.querySelectorAll('[data-countdown-timer]');
    if (!timerEls.length) return;

    function updateTimer() {
      // Calculate current time in PKT (UTC + 5)
      const now = new Date();
      const utc = now.getTime() + now.getTimezoneOffset() * 60000;
      const pktTime = new Date(utc + 3600000 * 5);

      const dayOfWeek = pktTime.getDay(); // 0 is Sunday
      const hours = pktTime.getHours();

      // If Sunday or past 6 PM, set target to next delivery day 6 PM
      let target = new Date(pktTime);
      if (dayOfWeek === 0 || hours >= 18) {
        // Next working day 6:00 PM
        const daysToAdd = dayOfWeek === 0 ? 1 : (dayOfWeek === 6 ? 2 : 1);
        target.setDate(target.getDate() + daysToAdd);
      }
      target.setHours(18, 0, 0, 0);

      const diff = target - pktTime;
      if (diff <= 0) {
        timerEls.forEach(el => el.textContent = '00:00:00');
        return;
      }

      const h = Math.floor(diff / (1000 * 60 * 60));
      const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((diff % (1000 * 60)) / 1000);

      const formatted = [
        h.toString().padStart(2, '0'),
        m.toString().padStart(2, '0'),
        s.toString().padStart(2, '0')
      ].join(':');

      timerEls.forEach(el => el.textContent = formatted);
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // 2. Dynamic WhatsApp Order Link Builder on Variant Change
  function initWhatsAppVariantSync() {
    document.addEventListener('variant:change', function (evt) {
      const variant = evt.detail && evt.detail.variant;
      if (!variant) return;

      const waBtns = document.querySelectorAll('.wc-wa-btn, [data-wc-wa-block] .wc-wa-btn, .btn-whatsapp-order');
      const phone = (waBtns[0] && waBtns[0].dataset.waPhone) || '923186639550';
      const title = (waBtns[0] && waBtns[0].dataset.productTitle) || document.title;
      const price = variant.price ? 'Rs. ' + (variant.price / 100).toLocaleString() : '';
      const variantTitle = variant.title && variant.title !== 'Default Title' ? ' [' + variant.title + ']' : '';
      const url = window.location.href;

      waBtns.forEach(function (waBtn) {
        const message = `Salam Waseem Collection! I want to order this suit: ${title}${variantTitle} (${price}). Link: ${url}. Please confirm COD delivery.`;
        waBtn.href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

        // Sold out toggle for notify-me
        const notifyBox = document.getElementById('WCNotifyMeBox');
        if (notifyBox) {
          if (!variant.available) {
            notifyBox.style.display = 'block';
            waBtn.style.opacity = '0.7';
          } else {
            notifyBox.style.display = 'none';
            waBtn.style.opacity = '1';
          }
        }
      });
    });
  }

  // 3. Multi-Tier Free Shipping & VIP Reward Bar Hook
  function updateFreeShippingBar(cartTotalCents) {
    const bars = document.querySelectorAll('[data-wc-free-shipping-bar]');
    if (!bars.length) return;

    const tier1 = 300000; // Rs. 3,000
    const tier2 = 600000; // Rs. 6,000
    const tier3 = 900000; // Rs. 9,000

    bars.forEach(function(bar) {
      const progressEl = bar.querySelector('[data-free-shipping-progress]');
      const msgEl = bar.querySelector('[data-free-shipping-msg]');
      const step1 = bar.querySelector('#MilestoneStep1');
      const step2 = bar.querySelector('#MilestoneStep2');
      const step3 = bar.querySelector('#MilestoneStep3');

      let currentTier = 0;
      let amountNeeded = 0;
      let tierPercent = 0;

      if (cartTotalCents < tier1) {
        currentTier = 0;
        amountNeeded = tier1 - cartTotalCents;
        tierPercent = (cartTotalCents * 33.33) / tier1;
      } else if (cartTotalCents < tier2) {
        currentTier = 1;
        amountNeeded = tier2 - cartTotalCents;
        const tierSpan = tier2 - tier1;
        const tierProgress = cartTotalCents - tier1;
        tierPercent = 33.33 + (tierProgress * 33.33) / tierSpan;
      } else if (cartTotalCents < tier3) {
        currentTier = 2;
        amountNeeded = tier3 - cartTotalCents;
        const tierSpan = tier3 - tier2;
        const tierProgress = cartTotalCents - tier2;
        tierPercent = 66.66 + (tierProgress * 33.34) / tierSpan;
      } else {
        currentTier = 3;
        amountNeeded = 0;
        tierPercent = 100;
      }

      tierPercent = Math.min(100, Math.max(0, tierPercent));

      if (progressEl) {
        progressEl.style.width = tierPercent + '%';
      }

      if (step1) {
        if (currentTier >= 1) {
          step1.classList.add('is-active');
          const dot = step1.querySelector('.milestone-dot');
          if (dot) dot.textContent = '✓';
        } else {
          step1.classList.remove('is-active');
          const dot = step1.querySelector('.milestone-dot');
          if (dot) dot.textContent = '1';
        }
      }

      if (step2) {
        if (currentTier >= 2) {
          step2.classList.add('is-active');
          const dot = step2.querySelector('.milestone-dot');
          if (dot) dot.textContent = '✓';
        } else {
          step2.classList.remove('is-active');
          const dot = step2.querySelector('.milestone-dot');
          if (dot) dot.textContent = '2';
        }
      }

      if (step3) {
        if (currentTier >= 3) {
          step3.classList.add('is-active');
          const dot = step3.querySelector('.milestone-dot');
          if (dot) dot.textContent = '✓';
        } else {
          step3.classList.remove('is-active');
          const dot = step3.querySelector('.milestone-dot');
          if (dot) dot.textContent = '3';
        }
      }

      if (msgEl) {
        const leftFormatted = 'Rs. ' + Math.ceil(amountNeeded / 100).toLocaleString();
        if (currentTier === 0) {
          msgEl.innerHTML = `<span class="wc-free-ship-remaining"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B89758" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg><span>Add <strong>${leftFormatted}</strong> more for <strong>FREE Nationwide Delivery</strong></span></span>`;
        } else if (currentTier === 1) {
          msgEl.innerHTML = `<span class="wc-free-ship-tier2"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16A34A" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><span>🎉 <strong>FREE Delivery Unlocked!</strong> Add <strong>${leftFormatted}</strong> for <strong>Rs. 500 OFF (Duo Offer)</strong>!</span></span>`;
        } else if (currentTier === 2) {
          msgEl.innerHTML = `<span class="wc-free-ship-tier3"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#D97706" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg><span>🏷️ <strong>Rs. 500 OFF Unlocked!</strong> Add <strong>${leftFormatted}</strong> for <strong>Rs. 1,000 OFF (Wardrobe Offer)</strong>!</span></span>`;
        } else {
          msgEl.innerHTML = `<span class="wc-free-ship-unlocked"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16A34A" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg><span>🌟 <strong>Mubarak! All Rewards Unlocked!</strong> (Free Delivery + Flat Rs. 1,000 OFF Applied)</span></span>`;
        }
      }
    });
  }

  // Listen for Shopify AJAX cart updates
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      updateFreeShippingBar(evt.detail.cart.total_price);
    }
  });

  // 4. Notify Me Form Submission
  window.WCNotifySubmit = function (form) {
    const input = form.querySelector('input[name="whatsapp"]');
    const successMsg = form.querySelector('.wc-notify-me__success');
    if (!input || !input.value) return;

    // Save to localStorage
    const saved = JSON.parse(localStorage.getItem('wc_notify_requests') || '[]');
    saved.push({
      phone: input.value.trim(),
      product: form.querySelector('input[name="product_title"]').value,
      date: new Date().toISOString()
    });
    localStorage.setItem('wc_notify_requests', JSON.stringify(saved));

    input.value = '';
    if (successMsg) {
      successMsg.style.display = 'block';
    }
  };

  // 5. Automatic Navigation Link Healing (Auto-corrects swapped Contact <-> Shop/Catalog links)
  function fixSwappedNavLinks() {
    try {
      var links = document.querySelectorAll('a[href]');
      links.forEach(function (a) {
        var text = (a.textContent || '').trim().toLowerCase();
        var href = (a.getAttribute('href') || '').toLowerCase().trim();

        // Contact link pointing to collection or catalog
        var isContactText = text === 'contact' || text === 'contact us' || text === 'contact & shop' || text === 'contact & office' || text === 'contact & studio' || text.indexOf('contact') === 0;
        var isCollectionHref = href.indexOf('/collections') !== -1 || href.indexOf('/catalog') !== -1;
        if (isContactText && isCollectionHref) {
          a.setAttribute('href', '/pages/contact');
        }

        // Shop / Catalog link pointing to contact page
        var isShopText = text === 'shop' || text === 'shop all' || text === 'catalog' || text === 'all collections' || text === 'browse all unstitched' || text.indexOf('shop ') === 0;
        var isContactHref = href.indexOf('/pages/contact') !== -1 || href.indexOf('/contact') !== -1;
        if (isShopText && isContactHref) {
          a.setAttribute('href', '/collections/all');
        }
      });
    } catch (err) {
      console.warn('Waseem Collection nav sync notice:', err);
    }
  }

  // Global click-capture safeguard
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var text = (a.textContent || '').trim().toLowerCase();
    var href = (a.getAttribute('href') || '').toLowerCase().trim();

    if ((text === 'contact' || text === 'contact us' || text.indexOf('contact') === 0) && (href.indexOf('/collections') !== -1 || href.indexOf('/catalog') !== -1)) {
      e.preventDefault();
      window.location.href = '/pages/contact';
    } else if ((text === 'shop' || text === 'shop all' || text === 'catalog' || text.indexOf('shop ') === 0) && (href.indexOf('/pages/contact') !== -1 || href.indexOf('/contact') !== -1)) {
      e.preventDefault();
      window.location.href = '/collections/all';
    }
  }, true);

  // 6. Automatic Discount Code Preservation on Checkout
  document.addEventListener('click', function (e) {
    var checkoutLink = e.target && e.target.closest ? e.target.closest('a[href="/checkout"], a[href*="/checkout"]') : null;
    if (!checkoutLink) return;
    try {
      var savedCode = (localStorage.getItem('waseem_discount_code') || '').trim();
      var href = checkoutLink.getAttribute('href');
      if (savedCode && href && href.indexOf('discount=') === -1) {
        e.preventDefault();
        var separator = href.indexOf('?') !== -1 ? '&' : '?';
        window.location.href = href + separator + 'discount=' + encodeURIComponent(savedCode);
      }
    } catch (err) {}
  });

  // 7. Dynamic IP Geolocation on PDP (Personalized Delivery Reassurance)
  function initDynamicCityGeolocation() {
    var datesEl = document.getElementById('LiveEstimatedDeliveryDates');
    var cityLabel = document.getElementById('LiveDeliveryCityLabel');
    var cityBadge = document.getElementById('LiveCityBadge');
    var cityNameEl = document.getElementById('LiveCityName');
    var changeBtn = document.getElementById('BtnChangeCity');

    if (!datesEl) return;

    var majorCities = ['Lahore', 'Karachi', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan', 'Peshawar', 'Sialkot', 'Gujranwala', 'Hyderabad', 'Quetta'];

    function calculateDates(isMajorCity) {
      var now = new Date();
      var minDays = isMajorCity ? 2 : 3;
      var maxDays = isMajorCity ? 3 : 5;

      var minDate = new Date(now);
      minDate.setDate(minDate.getDate() + minDays);
      var maxDate = new Date(now);
      maxDate.setDate(maxDate.getDate() + maxDays);

      var options = { weekday: 'short', month: 'short', day: 'numeric' };
      return minDate.toLocaleDateString('en-US', options) + ' – ' + maxDate.toLocaleDateString('en-US', options) + ' via Leopards Courier';
    }

    function renderCity(cityName) {
      var safeCity = (cityName || '').trim();
      if (!safeCity || safeCity.toLowerCase() === 'pakistan') {
        if (cityLabel) cityLabel.innerHTML = 'Estimated Nationwide Delivery:';
        if (cityBadge) cityBadge.style.display = 'none';
        datesEl.innerHTML = calculateDates(true) + ' <span class="delivery-open-parcel-tag">· Open Parcel Allowed</span>';
        return;
      }

      var isMajor = majorCities.some(function (c) {
        return c.toLowerCase() === safeCity.toLowerCase();
      });

      if (cityLabel) {
        cityLabel.innerHTML = 'Estimated Delivery to <strong>' + safeCity + '</strong>:';
      }
      if (cityBadge && cityNameEl) {
        cityNameEl.textContent = safeCity;
        cityBadge.style.display = 'inline-flex';
      }
      datesEl.innerHTML = calculateDates(isMajor) + ' <span class="delivery-open-parcel-tag">· Open Parcel Allowed</span>';
    }

    // Check cached city
    try {
      var cachedCity = sessionStorage.getItem('wc_user_city');
      if (cachedCity) {
        renderCity(cachedCity);
      } else {
        // Fast asynchronous IP lookup with 1.5s timeout
        var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timeoutId = controller ? setTimeout(function () { controller.abort(); }, 1500) : null;

        fetch('https://ipapi.co/json/', { signal: controller ? controller.signal : undefined })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (timeoutId) clearTimeout(timeoutId);
            if (data && data.city && (data.country === 'PK' || data.country_name === 'Pakistan')) {
              var detectedCity = data.city;
              sessionStorage.setItem('wc_user_city', detectedCity);
              renderCity(detectedCity);
            } else if (data && data.city) {
              sessionStorage.setItem('wc_user_city', data.city);
              renderCity(data.city);
            } else {
              renderCity('Pakistan');
            }
          })
          .catch(function () {
            renderCity('Pakistan');
          });
      }
    } catch (e) {
      renderCity('Pakistan');
    }

    // Manual city change trigger
    if (changeBtn) {
      changeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var current = sessionStorage.getItem('wc_user_city') || 'Lahore';
        var userChoice = prompt('Apna delivery shahar darj karein (e.g. Lahore, Karachi, Islamabad, Faisalabad):', current);
        if (userChoice && userChoice.trim()) {
          var formatted = userChoice.trim();
          sessionStorage.setItem('wc_user_city', formatted);
          renderCity(formatted);
        }
      });
    }
  }

  // DOMContentLoaded initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDispatchCountdown();
      initWhatsAppVariantSync();
      fixSwappedNavLinks();
      initDynamicCityGeolocation();
    });
  } else {
    initDispatchCountdown();
    initWhatsAppVariantSync();
    fixSwappedNavLinks();
    initDynamicCityGeolocation();
  }

  // Expose global helper
  window.WC = window.WC || {};
  window.WC.updateFreeShippingBar = updateFreeShippingBar;

})();
